export enum AuditBeneficiaryActionType {
    INSERT = 'LINKED',
    UPDATE = 'RELATION CHANGED',
    DELETE = 'UNLINKED'
  }